import { calculateEntryAmount } from '@/services/utils';
angular.module('leanlaw').controller('SummaryTimeController', ['$scope', '$filter', "$timeout", "alerts", "reportsService", "exportJson", "singleRequest", "userService", function ($scope, $filter, $timeout, alerts, reportsService, exportJson, singleRequest, userService) {
  // $scope.filter is owned by sidebar
  $scope.sort = 'startTime';
  $scope.reverse = false;
  $scope.loading = true;
  async function load() {
    if ($scope.activeTab != "time") return;
    var query = queryFromFilter();
    if (!query) return;
    query.billed = 'any';
    query.billedState = undefined;
    $scope.loading = true;
    const me = await userService.me();
    singleRequest.apiCall("tabdetail-entries").listEntries(query).then(list => {
      if (!list) return;
      $scope.entries = list.entries.map(e => {
        const useDateHandling = me.features?.dateHandling && e.localDateTime?.date;
        return {
          ...e,
          date: useDateHandling ? e.localDateTime.date : e.date,
          amount: calculateEntryAmount(e.rate.amount, e.hours)
        };
      });
      $scope.total = {
        hours: $scope.entries.reduce((sum, e) => sum + e.hours, 0),
        cost: $scope.entries.reduce((sum, e) => sum + e.cost.amount, 0),
        amount: $scope.entries.reduce((sum, e) => sum + e.amount, 0)
      };
      $scope.loading = false;
    }).catch(err => {
      alerts.error(err);
      $scope.loading = false;
      console.log('err', $scope.loading);
    });
  }
  function queryFromFilter() {
    if (!$scope.filter) return; // Not ready yet
    if (!$scope.filter.filter) return;
    if (!$scope.cm) return;
    var query = reportsService.queryFromFilter($scope.filter);
    query.scope = null;
    if ($scope.cm.matter) {
      query.matterId = $scope.cm.matter.id;
    } else {
      query.clientId = $scope.cm.client.id;
    }
    return query;
  }
  $scope.export = function () {
    const exp = $scope.entries.map(a => {
      var line = {
        "Date": $filter("dateLogical")(a.startTime),
        "Description": a.description,
        "User": a.account ? a.account.name : "",
        "Matter": a.matter.label,
        "Hours": $filter("hoursDecimal")(a.hours),
        "BillingType": $filter("billingType")(a)
      };
      if ($scope.billable) {
        line["Amount"] = a.amount;
      }
      if ($scope.cost) {
        line["Value"] = a.cost.amount;
      }
      return line;
    });
    exportJson.downloadCsv(exp);
  };
  $scope.$on('commonFilterService-statechanged', (event, payload) => {
    load();
  });
  $scope.$on("report-sidebar-filterchange", (event, payload) => {
    load();
  });

  // Suffix is the active tab name for this view
  $scope.$on("summary-export-time", payload => {
    $scope.export();
  });
  $scope.$watch("cm", newValue => {
    load();
  });
  $scope.$watch("activeTab", newValue => {
    $timeout(load);
  });
}]);